var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtArrowsSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7V5H4.6l3.6-3.1L6.8.4.5 6l6.3 5.6 1.4-1.5L4.6 7zM27.2 8.4l-1.4 1.5 3.6 3.1H15v2h14.4l-3.6 3.1 1.4 1.5 6.3-5.6z"
  })));
}
export default SvgFtArrowsSwitch;